var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.copyInputId)?_c('button',{staticClass:"a-button-copy button-copy",attrs:{"title":_vm.textTitle,"data-confirm":_vm.textConfirm,"at-a-button-copy":_vm.atAttribute,"type":"button"},on:{"click":function($event){return _vm.copyInputValue($event, _vm.copyInputId)}}},[_c('span',{staticClass:"icon icon-copy"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }